export default __webpack_public_path__ + "static/media/unhrcbg.6f87ff73.jpg";